import { sendGet } from './axios';

export const getAllTags = () => sendGet(`/tags/all`);

export const getAllTagJobs = () => sendGet(`/tag-job/all`);
